<template>
  <div class="space-y-12 bg-white px-20 py-16">
    <h3 class="text-lg leading-6 font-medium text-gray-900">
      Order #{{ accOrder.number }} ({{ dateCreated }})
    </h3>
    <PreviewCustomerDetails :acc-order="accOrder" />
    <PreviewOrderDetails :acc-order="accOrder" />
  </div>
</template>

<script>
import moment from 'moment';
import PreviewCustomerDetails from './PreviewCustomerDetails.vue';
import PreviewOrderDetails from './PreviewOrderDetails.vue';

export default {
  components: { PreviewOrderDetails, PreviewCustomerDetails },
  props: {
    accOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dateCreated() {
      return moment(this.accOrder.dateCreated).format('DD MMM YYYY');
    },
  },
};
</script>
